/** Local authenticated response only. Never navigate to a provider or public storage URL. */
export function downloadAdminFile(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob), anchor = document.createElement("a");
  anchor.href = url; anchor.download = name; document.body.append(anchor); anchor.click(); anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
